var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-anonymous-default-export */
import { defaultLocale, localeOptions } from '../../constants/defaultValues';
import { CHANGE_LOCALE } from '../actions';
var INIT_STATE = {
    locale: localStorage.getItem('currentLanguage')
        ? localeOptions.filter(function (x) { return x.id === localStorage.getItem('currentLanguage'); }).length > 0
            ? localStorage.getItem('currentLanguage')
            : defaultLocale
        : defaultLocale,
};
export default (function (state, action) {
    if (state === void 0) { state = INIT_STATE; }
    switch (action.type) {
        case CHANGE_LOCALE:
            return __assign(__assign({}, state), { locale: action.payload });
        default:
            return __assign({}, state);
    }
});
